import React from "react";
import PropTypes from "prop-types";
import { 
    OrderedMap,
    // List
} from "immutable";
import { Row, Col, Card, Icon, Statistic, message } from "antd";
import CompanyCreateForm from "./forms/company-create-form";
import {
    STATE_STATUS,
    // GSTIN_REGEX
} from "./constants";
import CompanyService from "./services/company-los-services";
// import { AssociateRecord } from "records/index";
import {
    // CompanyProfileRecord,
    AssociateRecord
} from "./records";
import AddressCard from "./address-card";

// const LAYOUT_TYPES = keyMirror({
//     CARD: null
// });

const getProfileLayout = data => new OrderedMap({
    gstin: {
        span: 6,
        key: "gstin",
        label: "GSTIN",
        value: data.gstin,
        type: "CARD"
    },
    type: {
        span: 6,
        key: "type",
        label: "Type",
        value: data.companyType,
        type: "card"
    },
    constitution: {
        span: 6,
        key: "constitution",
        label: "Constitution",
        value: data.constitutionType,
        type: "card"
    },
    primary_relationship_manager: {
        span: 6,
        key: "primary_relationship_manager",
        label: "Primary RM",
        value: data.primary_relationship_manager && data.primary_relationship_manager.full_name,
        type: "card"
    }
});



class CompanyProfileDisplay extends React.Component {

    state = {
        salesManagers: [],
        gstin_address_fetch: false,
        gstin_address: null
    };

    formRef = React.createRef();
    componentDidMount() {
        this.props.fetchCompanyLosDetail(this.props.companyId);
        this.props.fetchRetailerMapping(this.props.companyId);
    }
    gstinValidation = {
        validator: async (rule, value, callback) => {
            callback();
            // if (value && this.gstin && this.gstin.gstin === value) {
            //     callback();
            // }
            // if (value && value.length > 0 && GSTIN_REGEX.test(value)) {
            //     const companies = await this.fetchCreatedCompanies(value);
            //     if (companies.length > 0) {
            //         this.showExistingCompanyModal(companies, callback());
            //     }
            //     const gstinBlob = await this.fetchGstin(value);

            //     if (gstinBlob && gstinBlob.gstin === value) {
            //         this.gstin = gstinBlob;
            //         const companyName = this.formRef.current.getFieldValue("name");

            //         if (!companyName || companyName.length === 0) {
            //             this.formRef.current.setFieldsValue({
            //                 name: this.gstin.tradeNam
            //             });
            //             callback();
            //         } else {
            //             this.confirmCompanyName(companyName, callback);
            //         }

            //     } else {
            //         callback("Invalid Gstin");
            //     }
            // }
        }
    }

    fetchGstin = gstin => {
        return CompanyService.parseGSTIN(gstin).then(({ data }) => data).catch(() => []);
    }
    fetchChannelProducts = search => {
        return CompanyService.getChannelProducts(search);
    }
    fetchSalesManagers = search => {
        return CompanyService.getSMList(search);
    }
    fetchDistributorManagers = search => {
        return CompanyService.getDSMList(search);
    }
    fetchVpSalesManagers = async search => {
        return CompanyService.getVPSMList(search);
    }
    fetchDRMManagers = search => {
        return CompanyService.getDRMList(search);
    }
    fetchIndustryTypes = async search => {
        return CompanyService.industryTypeList(search);
    }

    onValuesSubmit = (companyValues, spocValues, bankDetails, filteredUsers) => {
        const spocValuesPan = spocValues.map(el => el.pan); 

        const hasDuplicates = spocValuesPan.some((pan, index) => 
            spocValuesPan.indexOf(pan) !== index 
        );
    
        if (hasDuplicates) {
            message.error("Duplicate PAN found!");
            return true; 
        }
        if(bankDetails && (bankDetails.account_number.length > 18 || bankDetails.account_number.length <9)){
            message.error("Please enter valid account number.");
        }else {
            let companyData = this.props.profile.get("data");
            let bankArray = [];
            for (const [key, value] of Object.entries(this.props.profile.get("data").toJS().bank_accounts)) {
                let prevBankData = {
                    "bank_branch": value.bank_branch?.id ? value.bank_branch?.id:value.bank_branch,
                    "account_limit":value.account_limit,
                    "account_type":value.account_type,
                    "account_holder_name":value.account_holder_name,
                    "status":value.status,
                    "is_key_account":value.is_key_account,
                    "id":value.id,
                    "account_number":value.account_number,
                    "company":parseInt(this.props.companyId),
                    "associate":value.associate,
                    "is_active":true,
                };
                bankArray.push(prevBankData);
            }
            const companyType = Number(companyData.get("type"));
            const hierarchyForSubmit =
                companyType === 1 || companyType === 2
                    ? {
                        vp_sales: companyData.get("vp_sales"),
                        zonal_head: companyData.get("zonal_head"),
                        parent_industry: companyData.get("parent_industry"),
                    }
                    : null;
            const mergePayload = { ...companyValues };
            if (hierarchyForSubmit) {
                delete mergePayload.vp_sales;
                delete mergePayload.zonal_head;
                delete mergePayload.parent_industry;
                delete mergePayload.industry_head;
            }
            companyData = companyData.merge(mergePayload);
            if (hierarchyForSubmit) {
                companyData = companyData.merge(hierarchyForSubmit);
            }
            if(spocValues) {
                spocValues.map((_, k) => {
                    if(_.id) {
                        companyData = companyData.mergeIn(["associates", _.id], _);
                    } else {
                        companyData = companyData.setIn(["associates", k], new AssociateRecord({..._, is_key_contact: true, is_active: true}));
                    }
                });
            }
            if(filteredUsers && filteredUsers !== {}) {
                let userKeys = Object.keys(filteredUsers);
                userKeys.map(_ => {
                    companyData = companyData.setIn(["associates", Number(_), "is_active"], false);
                });
            }
            if(bankDetails) {
                let bankData = {
                    "bank_branch": bankDetails.bank_branch,
                    "account_limit":null,
                    "account_type":bankDetails.account_type,
                    "account_holder_name":bankDetails.account_holder_name,
                    "status":null,
                    "is_key_account":false,
                    "id":null,
                    "account_number":bankDetails.account_number,
                    "company":parseInt(this.props.companyId),
                    "associate":null,
                    "is_active":true,
                };
                bankArray.push(bankData);
                companyData = companyData.updateDisbursalAccount(bankDetails);
                this.props.updateCompanyDisbursalAccount(this.props.companyId, bankArray);
            }
            this.props.updateCompanyLosProfile(this.props.companyId, companyData);
            const values = this.props.detail.get("data");
            const allAnchorId = [];
            const allIndustriesId = [];
            companyValues.all_anchors.map(item => allAnchorId.push(item.id));
            companyValues.all_industries.map(item => allIndustriesId.push(item.id));
            this.props.updateCompanyLosDetail(
                this.props.companyId,
                this.props.detail && values && {
                    ...values, 
                    all_anchors: allAnchorId,
                    all_industries: allIndustriesId,
                    industry: companyValues.industry.id,
                    program_anchor: companyValues.program_anchor && companyValues.program_anchor.id,
                    anchor: values.anchor && values.anchor.id,
                    location: values.location && values.location.id,
                    date: values.date && values.date.format("YYYY-MM-DD"),
                    headquarter: values.headquarter && values.headquarter.id,
                    anchor_yoa: values.anchor_yoa && +(values.anchor_yoa.format("YYYY")),
                    corporate_relationship_manager: values.corporate_relationship_manager && values.corporate_relationship_manager.id,
                    distributor_service_manager: companyValues.distributor_service_manager && companyValues.distributor_service_manager.id,
                    annual_turnover: companyValues.annual_turnover ? +companyValues.annual_turnover : null,
                    total_no_of_dealers: companyValues.total_no_of_dealers ? +companyValues.total_no_of_dealers : null
                }
            );
        }
    }

    getCompanyValues() {
        if (this.props.profile && this.props.profile.get("status") === STATE_STATUS.UPDATING) {
            const valueMap = this.props.profile && this.props.profile.get("newData");
            if (valueMap) {
                return valueMap.form;
            }
        }
        const valueMap = this.props.profile && this.props.profile.get("data");
        if (valueMap) {
            return valueMap.form;
        }
        return null;
    }

    getSpocValues() {
        if (this.props.profile && this.props.profile.get("status") === STATE_STATUS.UPDATING) {
            const valueMap = this.props.profile && this.props.profile.get("newData");
            if (valueMap) {
                return valueMap.spoc_user_form;
            }
        }
        const valueMap = this.props.profile && this.props.profile.get("data");
        if (valueMap && valueMap.spoc_user_form) {
            return valueMap.spoc_user_form;
        }
        return null;
    }

    getDisbursalAccountDetails() {
        if(this.props.profile && this.props.profile.get("status") === STATE_STATUS.UPDATING) {
            const valueMap = this.props.profile && this.props.profile.get("newData");
            if (valueMap) {
                return valueMap.disbursal_bank_account;
            }
        }
        const valueMap = this.props.profile && this.props.profile.get("data");
        if(valueMap && valueMap.disbursal_bank_account) {
            return valueMap.disbursal_bank_account;
        }
        return null;
    }

    getLoading() {
        const status = this.props.profile && this.props.profile.get("status");
        if (status === STATE_STATUS.UPDATING || status === STATE_STATUS.FETCHING) {
            return true;
        }
        return false;
    }
    getExtra() {
        const status = this.props.profile && this.props.profile.get("status");
        if (status === STATE_STATUS.UPDATING) {
            return <div>Updating...<Icon type={"loading"} /></div>;
        }
        if (status === STATE_STATUS.FETCHING) {
            return <div>Fetching...<Icon type={"loading"} /></div>;
        }
        if (status === STATE_STATUS.UPDATED) {
            return <div>Updated <Icon type={"check-circle"} /></div>;
        }
        if (status === STATE_STATUS.UPDATE_FAILED) {
            return <div>Update Failed <Icon type={"close"} /></div>;
        }
        if (status === STATE_STATUS.FETCH_FAILED) {
            return <div> Fetch Failed <Icon type={"close"} /></div>;
        }
        return null;
    }
    render() {
        const { permissions, userGroups } = this.props;
        const hasCompanyProfileEdit = Boolean(permissions?.get("company_profile_edit"));
        const isCompanyProfileEditGroup = (userGroups?.toArray?.() ?? userGroups ?? []).some(
            (id) => +id === 37
        );

        return <Row>
            <Col span={18} offset={3} className={"pb-5"}>
                <Row gutter={24}>
                    {
                        getProfileLayout(this.props.profile.get("data")).map(_ =>
                            (
                                <Col key={_.key} span={_.span}>
                                    <Card title={null} className={"border-none"} size={"default"} >
                                        {/* {_.value} */}
                                        <Statistic
                                            valueStyle={{
                                                fontSize: "16px",
                                                fontWeight: 500
                                            }}
                                            title={_.label}
                                            value={_.value || "--"} 
                                        />
                                    </Card>
                                </Col>
                            )
                        ).toList()
                    }
                </Row>
            </Col>
            <Col span={18} offset={3}>
                <CompanyCreateForm
                    fetchCompanyLosProfile={this.props.fetchCompanyLosProfile}
                    companyValues={this.getCompanyValues()}
                    spocValues={this.getSpocValues()}
                    bankDetails={this.getDisbursalAccountDetails()}
                    ref={this.formRef}
                    gstinValidator={this.gstinValidation}
                    fetchChannelProducts={this.fetchChannelProducts}
                    fetchSalesManagers={this.fetchSalesManagers}
                    fetchDistributorManagers={this.fetchDistributorManagers}
                    fetchDRMManagers={this.fetchDRMManagers}
                    salesManagers={this.state.salesManagers}
                    onValuesSubmit={this.onValuesSubmit}
                    loading={this.getLoading()}
                    userGroups={this.props.userGroups}
                    disableFields={!hasCompanyProfileEdit}
                    disableApplicantFields={!isCompanyProfileEditGroup}
                    gstin={this.props.profile.getIn(["data", "gstin"])}
                    detail={this.props.detail && this.props.detail.get("data")}
                    addRetailerMapping={this.props.addRetailerMapping.bind(null, this.props.companyId)}
                    retailerMapping={this.props.retailerMapping}
                    fetchRetailerMapping={this.props.fetchRetailerMapping}
                    retailerMappingStatus={this.props.retailerMappingStatus}
                    retailerMappingError={this.props.retailerMappingError}
                    fetchIndustryTypes={this.fetchIndustryTypes}
                    fetchVpSalesManagers={this.fetchVpSalesManagers}
                    vpSalesManagers={this.state.vpSalesManagers}
                    companyId={this.props.companyId}
                    profile = {this.props.profile}
                    isDBOnBoarding={this.props.isDBOnBoarding}
                />
            </Col>
            <Col span={18} offset={3} className={"mt-10"}>
                <Row className={"d-flex justify-content-space-between"}>
                    <Col span={12} className={"mr-10 mb-10"}>
                        <AddressCard
                            companyId={this.props.companyId}
                            title={"Registered Address"}
                            type={"Registered"}
                            address={this.props.profile.get("data").registered_address}
                            isUserAllowedToEdit={this.props.permissions.get("company_profile_edit")}
                            status={this.props.addressesStatus}
                            update={this.props.updateCompanyAddress}
                        />
                    </Col>
                    <Col span={12} className={"mb-10"}>
                        <AddressCard
                            companyId={this.props.companyId}
                            title={"Operating Address"}
                            type={"Office"}
                            isUserAllowedToEdit={this.props.permissions.get("company_profile_edit")}
                            optionalAddress={this.props.profile.get("data").registered_address}
                            optionalAddressLabel={"Same as Registered"}
                            address={this.props.profile.get("data").operating_address}
                            status={this.props.addressesStatus}
                            update={this.props.updateCompanyAddress}
                        />
                    </Col>
                </Row>
            </Col>
        
        </Row>;
    }
}


CompanyProfileDisplay.propTypes = {
    location: PropTypes.object,
    history: PropTypes.object,
    fetchCompanyLosProfile: PropTypes.func,
    updateCompanyLosProfile: PropTypes.func,
    updateCompanyDisbursalAccount: PropTypes.func,
    companyId: PropTypes.string,
    profile: PropTypes.object,
    permissions: PropTypes.object,
    updateCompanyAddress: PropTypes.func,
    addressesStatus: PropTypes.string,
    detail: PropTypes.object,
    updateCompanyLosDetail: PropTypes.func,
    fetchCompanyLosDetail: PropTypes.func,
    addRetailerMapping: PropTypes.func,
    fetchRetailerMapping: PropTypes.func,
    retailerMapping: PropTypes.array,
    retailerMappingStatus: PropTypes.string,
    retailerMappingError: PropTypes.object
};

export default CompanyProfileDisplay;